<ng-content select="wma-card-header, [wma-card-header], [wmaCardHeader]" />
<ng-content select="wma-card-content, [wma-card-content], [wmaCardContent]" />

<ng-content />

<ng-content select="wma-card-footer, [wma-card-footer], [wmaCardFooter]" />
